<div class="flex-grow-1 py-3 mt-4">
  <div class="mb-3">
    <h1 class="fs-5 fw-bold mb-0">Affiliate report</h1>
  </div>

  <div class="card shadow border-0 mb-3 fade-in-zoom">
    <div class="card-body">
      <div class="row g-3 align-items-end">
        <div class="col-auto">
          <app-date-range-selector [date]="'this-month'" [zone]="'Europe/Paris'" (dateChanged)="dateChanged($event)"></app-date-range-selector>
        </div>

        <div class="col">
          <label class="form-label fw-bold small">Advertiser</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-filter"></i></span>
            <app-dropdown-select [multiple]="true" [selectAll]="true" [(ngModel)]="filters.values['advertisers']" (ngModelChange)="onAdvertiserChange()" placeholder="All advertisers">
              @for (advertiser of advertisers; track advertiser.id) {
                <app-dropdown-select-option [value]="advertiser.id">{{ advertiser.companyName }}</app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>

        <div class="col">
          <label class="form-label fw-bold small">Brand</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-filter"></i></span>
            <app-dropdown-select [multiple]="true" [selectAll]="true" [(ngModel)]="filters.values['products']" placeholder="All products">
              @for (product of filteredProducts; track product.id) {
                <app-dropdown-select-option [value]="product.id">{{ product.name }}</app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>

        <div class="col">
          <label class="form-label fw-bold small">Affiliate</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-filter"></i></span>
            <app-dropdown-select [multiple]="true" [selectAll]="true" [(ngModel)]="filters.values['affiliates']" placeholder="All affiliates">
              @for (affiliate of affiliates; track affiliate.id) {
                <app-dropdown-select-option [value]="affiliate.id">{{ affiliate.companyName }}</app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>

        <div class="col-auto">
          <button class="btn btn-primary fw-bold" (click)="applyFilters()">
            <i class="bi bi-search me-1"></i> Apply
          </button>
          <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
            <i class="bi bi-floppy"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
            <i class="bi bi-eraser"></i>
          </button>
        </div>

        <div class="col-auto ms-auto">
          <button class="btn btn-outline-primary fw-bold" (click)="downloadCsv()" [disabled]="loading">
            <i class="bi bi-file-earmark-spreadsheet me-1"></i> Download CSV
          </button>
        </div>
      </div>
    </div>
  </div>

  @if (!loading) {
    <div class="card border-0 shadow mb-3">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead>
              <tr>
                <th class="cursor-pointer" (click)="sort('name')">
                  Affiliate <i class="bi ms-1" [ngClass]="getSortIcon('name')"></i>
                </th>
                <th class="cursor-pointer" (click)="sort('id')">
                  AffID <i class="bi ms-1" [ngClass]="getSortIcon('id')"></i>
                </th>
                <th class="text-end cursor-pointer" (click)="sort('volume')">
                  Volume of leads <i class="bi ms-1" [ngClass]="getSortIcon('volume')"></i>
                </th>
                <th class="text-end bg-success-subtle border-success-subtle cursor-pointer" (click)="sort('averageCplUsd')">
                  Avg CPL (USD) <i class="bi ms-1" [ngClass]="getSortIcon('averageCplUsd')"></i>
                </th>
                <th class="text-end border-success-subtle bg-success-subtle cursor-pointer" (click)="sort('averageCplEur')">
                  Avg CPL (EUR) <i class="bi ms-1" [ngClass]="getSortIcon('averageCplEur')"></i>
                </th>
                <th class="text-end bg-warning-subtle cursor-pointer" (click)="sort('spentUsd')">
                  Spent (USD) <i class="bi ms-1" [ngClass]="getSortIcon('spentUsd')"></i>
                </th>
                <th class="text-end bg-warning-subtle cursor-pointer" (click)="sort('spentEur')">
                  Spent (EUR) <i class="bi ms-1" [ngClass]="getSortIcon('spentEur')"></i>
                </th>
                <th class="text-end bg-info-subtle cursor-pointer" (click)="sort('totalSpentUsd')">
                  Total spent (USD) <i class="bi ms-1" [ngClass]="getSortIcon('totalSpentUsd')"></i>
                </th>
                <th class="text-end bg-info-subtle cursor-pointer" (click)="sort('totalSpentEur')">
                  Total spent (EUR) <i class="bi ms-1" [ngClass]="getSortIcon('totalSpentEur')"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (affiliate of rows; track affiliate.id) {
                <!-- Affiliate row (Level 0) -->
                <tr class="cursor-pointer" (click)="toggleAffiliate(affiliate.id)">
                  <td class="fw-bold">
                    <i class="bi me-1" [class.bi-chevron-right]="isAffiliateCollapsed(affiliate.id)"
                       [class.bi-chevron-down]="!isAffiliateCollapsed(affiliate.id)"></i>
                    {{ affiliate.name }}
                  </td>
                  <td>{{ affiliate.id }}</td>
                  <td class="text-end">{{ affiliate.totals.volume }}</td>
                  <td class="text-end bg-success-subtle">
                    {{ affiliate.totals.averageCplUsd | money:2:'USD' }}<span class="text-danger fa-fw ms-2">{{ affiliate.currency === 'USD' ? '¤' : ' ' }}</span>
                  </td>
                  <td class="text-end bg-success-subtle">{{ affiliate.totals.averageCplEur | money:2:'EUR' }}<span class="text-danger fa-fw ms-2">{{ affiliate.currency === 'EUR' ? '¤' : ' ' }}</span></td>
                  <td class="text-end bg-warning-subtle">{{ affiliate.totals.spentUsd | money:2:'USD' }}<span class="text-danger fa-fw ms-2">{{ affiliate.currency === 'USD' ? '¤' : ' ' }}</span></td>
                  <td class="text-end bg-warning-subtle">{{ affiliate.totals.spentEur | money:2:'EUR' }}<span class="text-danger fa-fw ms-2">{{ affiliate.currency === 'EUR' ? '¤' : ' ' }}</span></td>
                  <td class="text-end bg-info-subtle">{{ affiliate.totals.totalSpentUsd | money:2:'USD' }}</td>
                  <td class="text-end bg-info-subtle">{{ affiliate.totals.totalSpentEur | money:2:'EUR' }}</td>
                </tr>

                @if (!isAffiliateCollapsed(affiliate.id)) {
                  @for (product of affiliate.products; track product.id) {
                    <!-- Product row (Level 1) -->
                    <tr class="table-light cursor-pointer" (click)="toggleProduct(affiliate.id, product.id)">
                      <td class="ps-4">
                        <i class="bi me-1" [class.bi-chevron-right]="isProductCollapsed(affiliate.id, product.id)"
                           [class.bi-chevron-down]="!isProductCollapsed(affiliate.id, product.id)"></i>
                        {{ product.name }}
                      </td>
                      <td></td>
                      <td class="text-end">{{ product.totals.volume }}</td>
                      <td class="text-end bg-success-subtle">{{ product.totals.averageCplUsd | money:2:'USD' }}</td>
                      <td class="text-end bg-success-subtle">{{ product.totals.averageCplEur | money:2:'EUR' }}</td>
                      <td class="text-end bg-warning-subtle">{{ product.totals.spentUsd | money:2:'USD' }}</td>
                      <td class="text-end bg-warning-subtle">{{ product.totals.spentEur | money:2:'EUR' }}</td>
                      <td class="text-end bg-info-subtle">{{ product.totals.totalSpentUsd | money:2:'USD' }}</td>
                      <td class="text-end bg-info-subtle">{{ product.totals.totalSpentEur | money:2:'EUR' }}</td>
                    </tr>

                    @if (!isProductCollapsed(affiliate.id, product.id)) {
                      <!-- Language rows (Level 2) -->
                      @for (lang of product.languages; track lang.language) {
                        <tr>
                          <td class="ps-5">{{ lang.language || '-' }}</td>
                          <td></td>
                          <td class="text-end">{{ lang.volume }}</td>
                          <td class="text-end bg-success-subtle">{{ lang.averageCplUsd | money:2:'USD' }}</td>
                          <td class="text-end bg-success-subtle">{{ lang.averageCplEur | money:2:'EUR' }}</td>
                          <td class="text-end bg-warning-subtle">{{ lang.spentUsd | money:2:'USD' }}</td>
                          <td class="text-end bg-warning-subtle">{{ lang.spentEur | money:2:'EUR' }}</td>
                          <td class="text-end bg-info-subtle">{{ lang.totalSpentUsd | money:2:'USD' }}</td>
                          <td class="text-end bg-info-subtle">{{ lang.totalSpentEur | money:2:'EUR' }}</td>
                        </tr>
                      }

                      <!-- Product TOTAL row -->
                      <tr class="fw-bold">
                        <td class="ps-5">TOTAL</td>
                        <td></td>
                        <td class="text-end">{{ product.totals.volume }}</td>
                        <td class="text-end bg-success-subtle">{{ product.totals.averageCplUsd | money:2:'USD' }}</td>
                        <td class="text-end bg-success-subtle">{{ product.totals.averageCplEur | money:2:'EUR' }}</td>
                        <td class="text-end bg-warning-subtle">{{ product.totals.spentUsd | money:2:'USD' }}</td>
                        <td class="text-end bg-warning-subtle">{{ product.totals.spentEur | money:2:'EUR' }}</td>
                        <td class="text-end bg-info-subtle">{{ product.totals.totalSpentUsd | money:2:'USD' }}</td>
                        <td class="text-end bg-info-subtle">{{ product.totals.totalSpentEur | money:2:'EUR' }}</td>
                      </tr>
                    }
                  }
                }
              }
            </tbody>
            <tfoot>
              <tr class="fw-bold">
                <td colspan="2">GRAND TOTAL</td>
                <td class="text-end">{{ totals.volume }}</td>
                <td class="text-end">{{ totals.averageCplUsd | money:2:'USD' }}</td>
                <td class="text-end">{{ totals.averageCplEur | money:2:'EUR' }}</td>
                <td class="text-end">{{ totals.spentUsd | money:2:'USD' }}</td>
                <td class="text-end">{{ totals.spentEur | money:2:'EUR' }}</td>
                <td class="text-end">{{ totals.totalSpentUsd | money:2:'USD' }}</td>
                <td class="text-end">{{ totals.totalSpentEur | money:2:'EUR' }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  }
</div>
